module.exports = __webpack_public_path__ + "img/z4.b95fa8dc.png";